(function() {
    'use strict';

    angular
        .module('vobeApp')
        .component('voucherTilesSlick', {
            templateUrl: 'app/components/vouchers/layouts/voucher-tiles-slick.html',
            controller: 'VoucherTilesSlickController',
            controllerAs: 'vm',
            bindings: {
                slickSettings: '<',//like vm.settings
                allVouchers: '<',
                onlyFeatured: '<',
                viewLayoutTileDesign : '<',//default or text
                viewLayout : '<',
                tilesSettings: '<',//like vm.settings
                appliedPromotionCode: '<',
                channel: '<',
                voucherPoolObject: '<',
                currentProperty: '<',
                currentPropertyGroup: '<',
                shoppingCart: '<',
                websiteType: '<',//group or property
                descriptionLines: '<',
                openPackageModal: '<',//function
                openCashModal: '<',//function
                groupCategories: '<',
                propertyCategories: '<',
                filterPrice: '<',//function
                filterCategory: '<',//function
                filterGiftCardByVoucherClass: '<',
                filterCashOnly: '<',
                filterVouchersByFeatured: '<'
            }
        });
})();
